import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import PaginationItem from './PaginationItem';
import PaginationContext from '../data/PaginationContext';
import { StyledPaginationList } from './PaginationNav.styles';

var PaginationNav = function PaginationNav(_ref) {
  var paginationInfo = _ref.paginationInfo;

  var _ref2 = useContext(PaginationContext) || paginationInfo,
      items = _ref2.items;

  return /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": "Pagination Navigation"
  }, /*#__PURE__*/React.createElement(StyledPaginationList, null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(PaginationItem, _extends({
      key: index
    }, item));
  })));
};

export default PaginationNav;